import { qnTexts } from '../themes/_palette';

export const MuiDateCalendar = {
    styleOverrides: {
        root: {
            boxShadow: "0px - 1px 2px rgb(103 115 180 / 10 %), 0px 2px 3px rgb(103 115 180 / 13 %)",
            borderRadius: 8,
            border: `1px solid var(--mui-palette-secondary-main)`,
            overflow: 'hidden',
            margin: 0,
            width: '300px',
            "& > div:first-of-type": {
                position: 'relative', // [GM]: navigation header
                "& > div:first-of-type": {
                    "& .PrivatePickersFadeTransitionGroup-root": {
                        color: qnTexts.darkGreyMediumEmphasis
                    },
                    marginLeft: 'auto', // [GM]: month + year header is center
                },
                "& > div:last-of-type": {
                    "& > div": {
                        display: 'none' // [GM]: remove div space between arrow buttons
                    },
                    "& > button:first-of-type": {
                        "[dir=rtl] &": {
                            transform: 'scaleX(-1)'
                        },
                        position: 'absolute',
                        top: 0,
                        left: 24, // [GM]: left arrow button position
                        justifyContent: 'left',
                        width: '1em'
                    },
                    "& > button:last-of-type": {
                        "[dir=rtl] &": {
                            transform: 'scaleX(-1)'
                        },
                        position: 'absolute',
                        top: 0,
                        right: 24, // [GM]: right arrow button position
                        justifyContent: 'right',
                        width: '1em'
                    }
                }
            },
            "& .MuiDayCalendar-root": {
                    "& .MuiDayCalendar-header": {
                        columnGap: '3px',
                        "& .MuiTypography-root": {
                            margin: 0
                        }
                    },
                    "& .MuiDayCalendar-weekContainer": {
                        columnGap: '3px',
                    },
                    "& .MuiDayCalendar-monthContainer": {
                        minHeight: 200,
                        "& .MuiPickersDay-root": {
                            "&.Mui-selected": {
                                color: '#fff',
                                backgroundColor: 'var(--mui-palette-primary-main)'
                            },
                            margin: 2,
                            color: 'var(--mui-palette-primary-textColor)',
                            height: 32,
                            width: 32,
                            fontSize: 14,
                            ":hover": {
                                border: `1px solid var(--mui-palette-primary-main)`
                            },
                            ":      focus": {
                                border: `1px solid var(--mui-palette-primary-main)`
                            },
                            ":disabled": {
                                backgroundColor: 'unset'
                            },
                        }
                    }
            }
        }
    }
}
